// import {useState} from 'react'
import React, { Fragment, useState } from 'react';    
import {useDispatch} from 'react-redux'
import { createEntry } from '../features/entries/entrySlice'   

function EntryForm() {
  const [name, setName] = useState('');
  const [alias, setAlias] = useState('');
  const [medicalCond, setMedicalCond] = useState('');
  const [rfa, setRfa] = useState('');

  const dispatch = useDispatch();
  const onSubmit = (e) => {
    e.preventDefault()           
    dispatch(createEntry({ name, alias, medicalCond, rfa }))

    setName('')
    setAlias('')
    setMedicalCond('')
    setRfa('')         
    /* I'm guessing this is for the initial value. But what's the 
    point if that's already done w/ useState('')? */
  }

  return (
    <section className='form'>
      <form onSubmit={onSubmit}>
        <div className="form-group">

          <label htmlFor='name'>Name</label>
          <input type='text' 
            name='name' 
            id='name' 
            value={name} 
            onChange={(e) => setName(e.target.value)}
          />
          <label htmlFor='alias'>Alias (optional)</label>
          <input type='text' name='alias' id='alias' value={alias} onChange={(e) => setAlias(e.target.value)}/>

          <label htmlFor='medicalCond'>RFA (Reason For Admittance)</label>
          <input type='text' 
            name='medicalCond' 
            id='medicalCond' 
            value={medicalCond} 
            onChange={(e) => setMedicalCond(e.target.value)}
          />

          <label htmlFor='rfa'>Additional Info</label>
          <input type='text' name='rfa' id='rfa' value={rfa} onChange={(e) => setRfa(e.target.value)}/>
        </div>

        {/* created with .form-group */}
        <div className="form-group">
          {/* created with button.btn.btn-block */}
          <button className="btn btn-block" type='submit'>
            Add Inmate
          </button>
        </div>  
      </form>
    </section>
  )
}

export default EntryForm